export const sortByDateData = ["latest", "oldest"];
